import React, { Component } from 'react'

import ContMessageI18N from '../../containers/ContMessageI18N';

class ButtonListRange extends Component {

	suffix = '';
	callBack = function (value) { }

	constructor(props) {
		super(props);
		this.suffix = props.suffix != null ? props.suffix : '';
		this.callBack = props.onChange;
		this.state = ButtonListRange.getStateFromProps(props);
	}

	getMessage(i18nKey, arg, argType) { return <ContMessageI18N i18n={i18nKey} arg={arg} argType={argType} /> }

	static getStateFromProps(props) {
		var listValues = [];
		var minValue = null;
		if (props.min != null && props.max != null) {
			const listAndMinValues = ButtonListRange.buildListValuesAndMin(
				props.min, props.max, props.step, props.contextMin, props.contextMax);
			minValue = listAndMinValues.minValue;
			listValues = listAndMinValues.listValues;
		} else if (props.values != null) {
			listValues = props.values;
			minValue = Math.min(...props.values);
		}
		var value = (props.value != null) ? props.value : minValue;
		return { value: value, listValues: listValues }
	}
	static buildListValuesAndMin(min, max, step, contextMin, contextMax){
		let minValue = null;
		const listValues = [];
		for (var i = min; i <= max; i += step) {
			if ((contextMin == null || contextMin <= i) && (contextMax == null || contextMax >= i)) {
				listValues.push(i);
				if (minValue === null) {
					minValue = i
				}
			}
		}
		return {minValue:minValue,listValues:listValues};
	}

	//Méthode qui permet de mettre à jour l'état du composant sur une modification externe de la Props value
	static getDerivedStateFromProps(props, currentState) {
		if (currentState.value !== props.value
			|| currentState.contextMin !== props.contextMin
			|| currentState.contextMax !== props.contextMax) {
			return ButtonListRange.getStateFromProps(props);
		}
		return null
	}

	getValueStr(value) {
		if (this.props.i18nKey != null && this.props.i18nArgType != null) {
			return this.getMessage(this.props.i18nKey, value, this.props.i18nArgType);
		} else {
			return `${value} ${this.suffix}`;
		}
	}

	render() {
		return (
			<div className="container text-center">
				<div className="btn-group" role="group">
					{this.state.listValues.map((value, index) => (
						<React.Fragment key={index}>
							{this.state.value !== value &&
								<button type="button" className="btn btn-outline-primary"
									onClick={() => {
										this.setState({ value: value });
										this.callBack(value);
									}}
								>
									{this.getValueStr(value)}
								</button>}
							{this.state.value === value &&
								<button type="button" className="btn btn-primary" >{this.getValueStr(value)}</button>}
						</React.Fragment>
					))}
				</div>
			</div>
		)
	}
}

export default ButtonListRange
